const key = "QUESTIONNAIRE_TEMPLATE_DETAILS"

export const QUESTIONNAIRE_TEMPLATE_DETAILS = {
        CLEAR: `${key}_CLEAR`,
        SET_LOADING_TEMPLATE_DETAILS: `${key}_SET_LOADING_TEMPLATE_DETAILS`,
        SET_TEMPLATE_DETAILS_DATA:`${key}_SET_TEMPLATE_DETAILS_DATA`,
};
